module.exports = __webpack_public_path__ + "static/img/swiper7.2c7ba14a.png";